import { Button } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import type { CompetitionClubType } from 'types/competition';
import type { DrawClubType } from 'types/draw';
import CompetitionObject from './CompetitionObject';
import DrawChampionshipObject from './DrawChampionshipObject';

export const ClubRecentCompetitions: React.FC<{
  loading: boolean;
  competitions?: CompetitionClubType[];
  id?: number;
  title: string;
  draws?: DrawClubType[];
}> = ({ loading, id, competitions, title, draws }) => (
  <div
    id='container'
    className='border-neutral-neutral-2 bg-neutral-neutral-1 flex flex-col items-start gap-2 self-stretch rounded-2xl border border-solid p-3'
  >
    <div id='topbar' className='flex items-center justify-between gap-2 self-stretch'>
      <div className='text-neutral-neutral-12 self-stretch text-lg font-medium tracking-tight'>{title}</div>
      {id && (
        <Link className='flex self-end' to={`/circolo/${id}/competizioni`}>
          <Button variant='outline' size='2' className='cursor-pointer'>
            Vedi tutte
          </Button>
        </Link>
      )}
    </div>
    <div
      id='content'
      className='text-neutral-neutral-12 flex-1 items-center justify-between gap-2 self-stretch text-sm font-normal'
    >
      <div id='table' className='grid w-full grid-cols-1 flex-wrap items-start gap-2 self-stretch'>
        {competitions?.map((competition) => (
          <CompetitionObject key={competition.id} {...competition} loading={loading} />
        ))}

        {draws?.map((championship) => (
          <DrawChampionshipObject loading={loading} {...championship} key={championship.id} />
        ))}
      </div>
    </div>
  </div>
);

export default ClubRecentCompetitions;
